import { IUnit } from 'app/api/unit/model'
import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import {
  EmploymentStatus,
  IFilterTradeUnionList,
} from 'app/containers/TradeUnionMemberManagement/type'
import { usePagination } from 'app/hook'
import { useGetUnitList } from 'app/react-query/hook/unit'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useHookCommon } from '../hook'
import styled from 'styled-components'

interface IProps {
  onChangeFilter?: (filter: IFilterTradeUnionList) => void
  filter?: IFilterTradeUnionList
  isWithoutUnit?: boolean
}

export const FilterLayout: React.FC<IProps> = ({
  filter,
  onChangeFilter,
  isWithoutUnit,
}) => {
  const { t } = useTranslation()

  const { data, isLoading } = useGetUnitList({ limit: 10000 })

  const { flattenDataList } = usePagination()

  const units: IUnit[] = useMemo(
    () => flattenDataList(data)?.data ?? [],
    [data],
  )

  const onChangeSearch = (value: string) => {
    onChangeFilter?.({ ...filter, search: value })
  }

  const onChangeSource = (value: number) => {
    onChangeFilter?.({ ...filter, source: value })
  }

  const onChangeTTLV = (val?: EmploymentStatus) => {
    onChangeFilter?.({ ...filter, tinhTrangLamViec: val })
  }

  const onChangeTTSH = (ids?: number[]) => {
    onChangeFilter?.({ ...filter, activityIds: ids })
  }

  const onChangeUnitIds = (value: number[]) => {
    onChangeFilter?.({ ...filter, unitIds: value })
  }

  const onChangeSchoolIds = (value: number[]) => {
    onChangeFilter?.({ ...filter, schoolIds: value })
  }

  const onChangeDegreeIds = (value: number[]) => {
    onChangeFilter?.({ ...filter, degreeIds: value })
  }

  const {
    activityEngagement,
    isLoadingActivityEngagement,
    school,
    isLoadingSchool,
    degree,
    isLoadingDegree,
  } = useHookCommon()

  return (
    <BaseForm>
      <BaseRow gutter={[16, 0]}>
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <BaseInput
              placeholder={t(R.strings.search)}
              value={filter?.search}
              onChange={e => onChangeSearch?.(e?.target?.value)}
              allowClear
            />
          </BaseFormItem>
        </BaseCol>
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <BaseSelect
              placeholder={'Nguồn dữ liệu'}
              value={filter?.source}
              onChange={e => onChangeSource?.(e as number)}
              options={[
                {
                  value: 1,
                  label: 'Từ UEH',
                },
                {
                  value: 0,
                  label: 'Từ hệ thống công đoàn',
                },
              ]}
              allowClear
            />
          </BaseFormItem>
        </BaseCol>
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <BaseSelect
              placeholder={'Tình trạng làm việc'}
              value={filter?.tinhTrangLamViec}
              onChange={ids => onChangeTTLV?.(ids as EmploymentStatus)}
              allowClear
              showSearch
              options={Object.values(EmploymentStatus).map(val => ({
                label: val,
                value: val,
              }))}
            />
          </BaseFormItem>
        </BaseCol>
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <BaseSelect
              placeholder={'Tình trạng sinh hoạt'}
              value={filter?.activityIds}
              onChange={ids => onChangeTTSH?.(ids as number[])}
              allowClear
              showSearch
              options={activityEngagement?.map(itm => ({
                label: itm?.name,
                value: itm?.id,
              }))}
              loading={isLoadingActivityEngagement}
              mode="multiple"
              maxTagCount={1}
            />
          </BaseFormItem>
        </BaseCol>
        {!isWithoutUnit ? (
          <BaseCol xl={6}>
            <BaseFormItem hiddenLabel>
              <BaseSelect
                placeholder={'Đơn vị công đoàn'}
                value={filter?.unitIds}
                onChange={e => onChangeUnitIds?.(e as number[])}
                allowClear
                showSearch
                mode="multiple"
                options={
                  units?.map(item => ({ value: item.id, label: item.name })) ??
                  []
                }
                loading={isLoading}
              />
            </BaseFormItem>
          </BaseCol>
        ) : null}
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <BaseSelect
              placeholder={'Công đoàn bộ phận'}
              value={filter?.schoolIds}
              onChange={e => onChangeSchoolIds?.(e as number[])}
              allowClear
              showSearch
              mode="multiple"
              options={
                school?.data?.map(item => ({
                  value: item.id,
                  label: item.name,
                })) ?? []
              }
              loading={isLoadingSchool}
            />
          </BaseFormItem>
        </BaseCol>
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <BaseSelect
              placeholder={'Học vị'}
              value={filter?.degreeIds}
              onChange={ids => onChangeDegreeIds?.(ids as number[])}
              allowClear
              showSearch
              options={degree?.data?.map(itm => ({
                label: itm?.name,
                value: itm?.id,
              }))}
              loading={isLoadingDegree}
              mode="multiple"
              maxTagCount={1}
            />
          </BaseFormItem>
        </BaseCol>
      </BaseRow>
    </BaseForm>
  )
}

const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px !important;
`
